import React, { useState } from 'react';
import { Icon } from '../../elements/icon';

const InfoPill = ({ type, text, whyLabel, dykLabel }) => {
  const [isOpen, setIsOpen] = useState(false);

  const isWhy = type === 'why';
  const pillClass = isWhy ? 't-text-quiz-teal t-bg-quiz-teal/[.07]' : 't-text-[#8B6914] t-bg-butter/[.12]';
  const panelBg = isWhy
    ? 't-bg-quiz-teal/[.07] t-border-l-[3px] t-border-l-quiz-teal'
    : 't-bg-butter/[.12] t-border-l-[3px] t-border-l-butter';

  return (
    <div className="t-mb-3">
      <div className="t-flex t-gap-1.5 t-flex-wrap t-my-2">
        <button
          type="button"
          className={`t-inline-flex t-items-center t-gap-[5px] t-px-3 t-py-[5px] t-rounded-2xl t-text-[11px] t-font-semibold t-cursor-pointer t-border-0 t-font-sans ${pillClass}`}
          onClick={() => setIsOpen(!isOpen)}
        >
          <Icon name={isWhy ? 'whyCircle' : 'starBurst'} size={12} raw />
          {isWhy ? whyLabel || 'Why we ask' : dykLabel || 'Did you know?'}
        </button>
      </div>
      <div
        className="t-overflow-hidden t-transition-all t-duration-300 t-ease-in-out"
        style={{ maxHeight: isOpen ? 220 : 0, opacity: isOpen ? 1 : 0 }}
      >
        <div
          className={`t-p-2.5 t-px-3.5 t-rounded-[10px] t-text-[12.5px] t-leading-relaxed t-mb-3 ${panelBg}`}
        >
          {text}
        </div>
      </div>
    </div>
  );
};

export default InfoPill;
